import { tracking, trackProjectHiredStatusChange } from '@bark/bark-core';
import { SMSTemplatesManager } from '../components/sms/sms_template_manager';
import { SellerToolbar } from '../components/responses/seller_toolbar';
import { SellerViewport } from '../components/responses/seller_viewport';
import { SellerResponses } from '../components/responses/seller_responses';
import { DashboardEmailTemplates } from '../components/leads/dashboard_email_templates';
import { SendEstimate } from '../components/estimate/send_estimate';
import { CallBuyerModal } from '../components/call-buyer/call-buyer-modal';
import { ActivityLog } from "@bark/bark-core";
import moment from 'moment';
import {
	cfbAddCopyToClipboardButton,
	cfbBindCopyToClipboardButtonListener,
	cfbRemoveCopyToClipboardButton,
	cfbDisplayShowNumberLink,
	cfbResetDisplayShowNumberLink,
	cfbDisplayPhoneNumberOnMobileButton,
	callFeedbackModalTracking,
} from '../components/call-feedback/call_feedback';
import CallFeedbackModal from '../components/call-feedback/call_feedback_modal';
import CallReminderModal from '../components/call-reminder/call_reminder_modal';
import { isCallReminderActive } from '../components/call-reminder/call_reminder';
import WhatsappResponseFeedbackModal from '../components/whatsapp/whatsapp_response_feedback_modal';
import { sendMessageFromWhatsapp } from '../components/whatsapp/whatsapp_response';
import BookingCancellationModal from '../components/responses/booking-cancellation-modal';
import { CreditsUsed } from "../components/responses/credits-used";
import { onBookingPageInit } from '../components/responses/booking-details';

export default async function () {
	try {
		const { Handlebars, Bark } = window;

		window.trackProjectHiredStatusChange = trackProjectHiredStatusChange;

		SendEstimate();
		CallBuyerModal();
		DashboardEmailTemplates();
		CreditsUsed();
		const bookingCancellationModal = BookingCancellationModal();
		const SMSTemplates = new SMSTemplatesManager();

		moment.fn.fromNowOrNow = function (a) {
			if (Math.abs(moment().diff(this)) < 60000) {
				//for the fist minute
				return _t('seller_responses:just-now');
			}
			return this.fromNow(a);
		};

		moment.defineLocale('responses', {
			relativeTime: {
				future: _t('seller_responses:future-time', { time_interval: '%s' }),
				past: _t('seller_responses:time-ago', { time_interval: '%s' }),
				s: _t('common:relative-time.short.seconds', { number: '%d' }),
				m: _t('common:relative-time.short.minutes', { number: '%d' }),
				mm: _t('common:relative-time.short.minutes', { number: '%d' }),
				h: _t('common:relative-time.short.hours', { number: '%d' }),
				hh: _t('common:relative-time.short.hours', { number: '%d' }),
				d: _t('common:relative-time.short.days', { number: '%d' }),
				dd: _t('common:relative-time.short.days', { number: '%d' }),
				M: _t('common:relative-time.short.months', { number: '%d' }),
				MM: _t('common:relative-time.short.months', { number: '%d' }),
				y: _t('common:relative-time.short.years', { number: '%d' }),
				yy: _t('common:relative-time.short.years', { number: '%d' }),
			},
		});

		Handlebars.registerHelper('select', function (value, options) {
			var $el = $('<select />').html(options.fn(this));
			$el.find('[value="' + value + '"]').attr({ selected: 'selected' });
			return $el.html();
		});

		$(document).ready(() => {
			const toolbar = new SellerToolbar();
			const viewport = new SellerViewport();
			const responses = new SellerResponses(toolbar);
			const activityLog = new ActivityLog('seller');
			const DashboardEmailTemplates = new window.Bark.DashboardEmailTemplates();
			const whatsappResponseFeedbackModal = WhatsappResponseFeedbackModal();
			const callFeedbackModal = CallFeedbackModal(activityLog);
			onBookingPageInit();

			if (isCallReminderActive()) {
				const callReminderModal = CallReminderModal(activityLog);
				activityLog.setRendererCallback(function () {
					callReminderModal.bindActivityLogListeners(activityLog);
				});
			}

			if (bookingCancellationModal.isEnabled()) {
				bookingCancellationModal.bindClickHandlers();
			}

			SMSTemplates.getTemplates();
			SMSTemplates.on('sms.custom_sent', function () {
				activityLog.redraw();
			});
			SMSTemplates.on('sms.template_sent', function () {
				activityLog.redraw();
			});
			SMSTemplates.on('got_templates', function () {
				toolbar.redraw();
			});
			let smsData = {
				buyerName: '',
				buyerPhone: '',
				smsType: 'none',
				projectResponseId: null,
			};

			const removeQueryParameter = (parameter) => {
				let params;
				let newSearch;
				let newLocation;

				if (!window.history || !window.history.replaceState) {
					return;
				}

				if (!window.URLSearchParams) {
					// @todo confirm whether babel provides this polyfill
					return;
				}

				params = new URLSearchParams(window.location.search);
				params.delete(parameter);

				newSearch = params.toString();

				newLocation =
					location.origin +
					location.pathname +
					(newSearch ? '?' + newSearch : '') +
					location.hash;

				window.history.replaceState(null, null, newLocation);
			};

			const setLastActivityOnResponseBar = (lastActivityDate) => {
				let project = responses.project;
				let label = '';
				let lastActivity = '';
				if (project) {
					switch (project.responseStatus) {
						case 3:
							label = _t('seller_responses:project-details.status.hired');
							lastActivity = project.responseStatusLastUpdated
								? project.responseStatusLastUpdated.fromNowOrNow()
								: '';
							break;
						case 2:
							label = _t('seller_responses:project-details.status.archived');
							lastActivity = project.responseStatusLastUpdated
								? project.responseStatusLastUpdated.fromNowOrNow()
								: '';
							break;
						default:
							label = _t('seller_responses:last-activity');
							// need to use local moment for fromNowOrNow function
							lastActivity = lastActivityDate
								? moment.unix(lastActivityDate.unix()).local().fromNowOrNow()
								: '';
					}

					$('.js-last-activity').empty().append(`${label} ${lastActivity}`);
				}
			};

			const mobileChecks = ['starting', 'show-project', 'back-to-list'];

			toolbar.registerDropdownButton({
				name: 'email-dropdown',
				icon: 'envelope',
				label: _t(
					'seller_responses:project-details.toolbar.email-dropdown-button.title.desktop',
				),
				mobile_label: _t(
					'seller_responses:project-details.toolbar.email-dropdown-button.title.mobile',
				),
				params: {
					value: 'dropdown',
				},
				callback: () => {},
				conditions: [() => DashboardEmailTemplates.templates.length > 0],
				children: [
					{
						name: 'btn-send-template',
						icon: 'envelope',
						label: _t(
							'seller_responses:project-details.toolbar.email-dropdown-button.options.send-template',
						),
						callback: () => {
							DashboardEmailTemplates.setProjectData(
								responses.project.projectId,
								responses.project.buyerName,
							);
							DashboardEmailTemplates.handleSendEmailClick();
							tracking('seller-leads-dashboard-&-responses', 'Send template email', {
								project_id: responses.project.projectId,
								project_response_id: responses.project.responseId,
								pagename: window.location.pathname,
								lead_type: 'project',
							});
						},
					},
					{
						name: 'btn-send-custom-template',
						icon: 'edit',
						label: _t(
							'seller_responses:project-details.toolbar.email-dropdown-button.options.send-custom-template',
						),
						callback: () => {
							DashboardEmailTemplates.setProjectData(
								responses.project.projectId,
								responses.project.buyerName,
							);
							DashboardEmailTemplates.handleSendCustomEmailClick();
						},
					},
				],
				weight: 2,
			});
			toolbar.registerButton({
				name: 'btn-send-custom-template',
				icon: 'envelope',
				label: _t(
					'seller_responses:project-details.toolbar.send-custom-button.title.desktop',
				),
				mobile_label: _t(
					'seller_responses:project-details.toolbar.send-custom-button.title.mobile',
				),
				params: {},
				callback: () => {
					DashboardEmailTemplates.setProjectData(
						responses.project.projectId,
						responses.project.buyerName,
					);
					DashboardEmailTemplates.handleSendCustomEmailClick();
					tracking('seller-leads-dashboard-&-responses', 'Send custom email', {
						project_id: responses.project.projectId,
						project_response_id: responses.project.responseId,
						pagename: window.location.pathname,
						lead_type: 'project',
					});
				},
				conditions: [() => DashboardEmailTemplates.templates.length === 0],
				weight: 2,
			});
			toolbar.registerButton({
				name: 'call-standard-desktop-new',
				icon: 'telephone',
				icon_end: 'open_in_new',
				label: _t('seller_common:show-number-button'),
				params: {},
				callback: () => {
					callFeedbackModalTracking({
						buyer_id: callFeedbackModal.getFromState('buyer_id'),
						project_id: callFeedbackModal.getFromState('project_id'),
						seller_profile_id: callFeedbackModal.getFromState('seller_profile_id'),
						booking_id: callFeedbackModal.getFromState('booking_id'),
						seller_call_feedback_sms:
							callFeedbackModal.getFromState('seller_call_feedback_sms') ?? false,
					})('View');

					callFeedbackModal.show();
					tracking('Experiment', 'call_feedback - show-number-button-clicked', {
						project_age: callFeedbackModal.getFromState('projectCreated'),
						primary_category: callFeedbackModal.getFromState('categoryName'),
						page: window.location.pathname,
					});
				},
				conditions: [
					() => {
						try {
							return responses.project.telephone && responses.project.telephone.length;
						} catch (e) {
							return false;
						}
					},
				],
				weight: 0,
			});

			const callButtonMobileNewTemplate = Handlebars.compile(
				document.getElementById('seller-call-button-mobile-new-template').innerHTML,
			);
			toolbar.registerButton({
				name: 'call-standard-mobile-new',
				template: callButtonMobileNewTemplate,
				icon: 'telephone',
				params: {},
				prevent_default: false,
				callback: () => {
					callFeedbackModalTracking({
						buyer_id: callFeedbackModal.getFromState('buyer_id'),
						project_id: callFeedbackModal.getFromState('project_id'),
						seller_profile_id: callFeedbackModal.getFromState('seller_profile_id'),
						booking_id: callFeedbackModal.getFromState('booking_id'),
						seller_call_feedback_sms:
							callFeedbackModal.getFromState('seller_call_feedback_sms') ?? false,
					})('View');

					callFeedbackModal.show();
					tracking('Experiment', 'call_feedback - button-with-number-clicked', {
						project_age: callFeedbackModal.getFromState('projectCreated'),
						primary_category: callFeedbackModal.getFromState('categoryName'),
						page: window.location.pathname,
					});
				},
				conditions: [
					() => {
						try {
							return responses.project.telephone && responses.project.telephone.length;
						} catch (e) {
							return false;
						}
					},
				],
				weight: 0,
			});
			toolbar.registerButton({
				name: 'whatsapp-standard',
				icon: 'whatsapp_white',
				label: _t('seller_response_flow:whatsapp.title'),
				params: {},
				callback: () => {
					sendMessageFromWhatsapp(
						whatsappResponseFeedbackModal.getFromState('buyerNumberFormatted'),
					);
					whatsappResponseFeedbackModal.show();
					tracking('seller-leads-dashboard-&-responses', 'whatsapp - button', {
						seller_profile_id:
							whatsappResponseFeedbackModal.getFromState('sellerProfileId'),
						project_id: whatsappResponseFeedbackModal.getFromState('projectId'),
						response_id: whatsappResponseFeedbackModal.getFromState('projectResponseId'),
						page: window.location.pathname,
					});
				},
				conditions: [
					() => {
						try {
							return (
								responses.project.telephoneFormatted &&
								responses.project.telephoneFormatted.length &&
								['api', 'manual'].includes(smsData.smsType)
							);
						} catch (e) {
							return false;
						}
					},
				],
				weight: 1,
			});
			toolbar.registerDropdownButton({
				name: 'sms-dropdown',
				icon: 'message',
				label: _t(
					'seller_responses:project-details.toolbar.sms-dropdown-button.title.desktop',
				),
				mobile_label: _t(
					'seller_responses:project-details.toolbar.sms-dropdown-button.title.mobile',
				),
				params: {
					value: 'dropdown',
				},
				callback: () => {},
				conditions: [() => SMSTemplates.hasTemplates(), () => smsData.smsType === 'api'],
				children: [
					{
						name: 'btn-send-sms',
						icon: 'message',
						label: _t(
							'seller_responses:project-details.toolbar.sms-dropdown-button.options.send-sms-btn',
						),
						callback: () => {
							SMSTemplates.loadTemplatePickerModal(smsData, () => {
								tracking(
									'seller-leads-dashboard-&-responses',
									'Send template SMS - success',
									{
										project_id: responses.project.projectId,
										project_response_id: responses.project.responseId,
										pagename: window.location.pathname,
										lead_type: 'project',
									},
								);
							});
							tracking('seller-leads-dashboard-&-responses', 'Send template SMS - view', {
								project_id: responses.project.projectId,
								project_response_id: responses.project.responseId,
								pagename: window.location.pathname,
								lead_type: 'project',
							});
						},
					},
					{
						name: 'btn-send-custom-sms',
						icon: 'edit',
						label: _t(
							'seller_responses:project-details.toolbar.sms-dropdown-button.options.send-custom-sms-btn',
						),
						callback: () => {
							let customSMS = SMSTemplates.newCustom(smsData);
							customSMS.loadCustomSMSModal(
								() => {
									tracking(
										'seller-leads-dashboard-&-responses',
										'Send custom SMS - success',
										{
											project_id: responses.project.projectId,
											project_response_id: responses.project.responseId,
											pagename: window.location.pathname,
											lead_type: 'project',
										},
									);
								},
								() => {},
							);
							tracking('seller-leads-dashboard-&-responses', 'Send custom SMS - view', {
								project_id: responses.project.projectId,
								project_response_id: responses.project.responseId,
								pagename: window.location.pathname,
								lead_type: 'project',
							});
						},
					},
				],
				weight: 20,
			});
			toolbar.registerButton({
				name: 'send-sms',
				icon: 'message',
				label: _t(
					'seller_responses:project-details.toolbar.send-sms-button.title.desktop',
				),
				mobile_label: _t(
					'seller_responses:project-details.toolbar.send-sms-button.title.mobile',
				),
				params: {},
				callback: () => {
					if (smsData.smsType === 'manual') {
						SMSTemplates.loadManualSMSModal(
							smsData,
							function () {
								responses.project.updateResponseContact('sms', true);
								setTimeout(() => {
									activityLog.redraw();
								}, 1000);
								Bark.logEvent(
									'sms-buyer',
									'smsed-buyer-manually',
									'seller-response-flow',
								);
							},
							function () {
								Bark.logEvent(
									'sms-buyer',
									'not-smsed-buyer-manually',
									'seller-response-flow',
								);
							},
						);
					} else {
						let customSMS = SMSTemplates.newCustom(smsData);
						customSMS.loadCustomSMSModal(
							() => {
								tracking(
									'seller-leads-dashboard-&-responses',
									'Send custom SMS - success',
									{
										project_id: responses.project.projectId,
										project_response_id: responses.project.responseId,
										pagename: window.location.pathname,
										lead_type: 'project',
									},
								);
							},
							() => {},
						);
						tracking('seller-leads-dashboard-&-responses', 'Send custom SMS - view', {
							project_id: responses.project.projectId,
							project_response_id: responses.project.responseId,
							pagename: window.location.pathname,
							lead_type: 'project',
						});
					}
				},
				conditions: [
					() => smsData.smsType === 'manual' || !SMSTemplates.hasTemplates(),
					() => smsData.smsType !== 'none',
				],
				weight: 20,
			});
			viewport.on('viewport-resize', () => {
				if (viewport.isMobile()) {
					if (responses.isViewingProject()) {
						responses.hideProjectList();
						responses.showMainProject();
					} else {
						responses.showProjectList();
						responses.hideMainProject();
					}
				} else {
					responses.showProjectList();
					responses.showMainProject();
				}
				activityLog.clampItems();
			});

			responses.on(mobileChecks, (responseController, callback) => {
				callback(viewport.isMobile());
			});
			responses.on('project-rendered', (responsesController, project) => {
				toolbar.setData(project);
				toolbar.render();
				activityLog.render(project.responseId);

				// this `project-rendered` event is fired twice, once on render and once in postRender function. is that a mistake?
				autosize($('.notes-input'));
				// Reset the send estimate modal
				Bark.sendEstimate &&
					Bark.sendEstimate.resetStatus({
						responseId: project.responseId,
						estimateAmount: project.quoteValue,
						estimateType: project.quoteFrequency,
						estimateMessage: project.quoteDetail,
					});
				Bark.api(
					'seller/messenger/read/' + project.responseId + '/',
					{},
					function (data) {},
					function (error) {},
					'POST',
					Bark.apiVersionHeader('v2'),
				);

				//Call feedback updates
				cfbRemoveCopyToClipboardButton($('#seller-call-button-mobile-new-container'));
				cfbResetDisplayShowNumberLink();

				callFeedbackModal.resetState();

				if (project.telephone) {
					let cfbData = {
						buyerName: project.buyerName,
						buyerNumber: project.telephone,
						projectResponseId: project.responseId,
						projectCreated: project?.created
							? moment(project.created).utc().fromNow()
							: '',
						categoryName: project.title,
						buyer_id: project.buyerId,
						seller_profile_id: Bark?.seller?.id,
						project_id: project.projectId,
						booking_id: QS.getValue('cbid', null),
						seller_call_feedback_sms: QS.getValue('sbfbm', null) == 1 ? true : false,
					};

					cfbAddCopyToClipboardButton($('#seller-call-button-mobile-new-container'));
					cfbBindCopyToClipboardButtonListener(
						$('#seller-call-button-mobile-new-container'),
						cfbData,
					);

					cfbDisplayPhoneNumberOnMobileButton(
						$('#seller-button-call-standard-mobile-new'),
						$('#seller-button-call-standard-mobile-new span.label.d-lg-none'),
						cfbData.buyerNumber,
					);

					cfbDisplayShowNumberLink();

					callFeedbackModal.setInState(cfbData);
					callFeedbackModal.bindShowNumberLinkListener();
					if (
						QS.hasKey('show_call_feedback') &&
						QS.getValue('show_call_feedback', false) &&
						!viewport.isMobile()
					) {
						callFeedbackModal.show();
						removeQueryParameter('show_call_feedback');
						QS.deleteValue('show_call_feedback', true);
					}

					if (
						QS.hasKey('prx') &&
						QS.getValue('sbfbm') == 1 &&
						QS.getValue('prx', false)
					) {
						callFeedbackModal.show(true);
						tracking('seller_call_feedback_sms', 'Seller-booking-call-feedback', {
							seller_profile_id: callFeedbackModal.getFromState('seller_profile_id'),
							buyer_user_id: callFeedbackModal.getFromState('buyer_id'),
							project_id: callFeedbackModal.getFromState('project_id'),
							booking_id: callFeedbackModal.getFromState('booking_id'),
							page: window.location.pathname,
						});
						QS.deleteValue('sbfbm', true);
					}
				}

				whatsappResponseFeedbackModal.resetState();
				if (project?.telephoneFormatted && project.telephoneFormatted.length) {
					whatsappResponseFeedbackModal.setInState({
						projectId: project.projectId,
						sellerProfileId: Bark?.seller?.id,
						projectResponseId: project.responseId,
						buyerName: project.buyerName,
						buyerNumberFormatted: project.telephoneFormatted,
					});
				}
			});
			$(document).on('shown.bs.tab', '#notes-tab', () => {
				setTimeout(() => {
					autosize.update($('.notes-input'));
				}, 100);
			});
			responses.on('project-set', (responsesController, project) => {
				activityLog.load(project.responseId);
				Bark.callBuyer &&
					Bark.callBuyer.resetStatus(project.buyerName || '', project.telephone);
				smsData.buyerName = project.buyerName;
				smsData.buyerPhone = project.telephone;
				smsData.smsType = project.buyerSupportedSmsType;
				if (QS.hasKey('force-sms-type')) {
					smsData.smsType = QS.getValue('force-sms-type');
				}
				smsData.projectResponseId = project.responseId;

				tracking('seller-leads-dashboard-&-responses', 'responses CTAs - viewed', {
					seller_profile_id: Bark?.seller?.id,
					project_id: project.projectId,
					response_id: project.responseId,
					page: window.location.pathname,
				});
			});

			responses.on('project-rendered-post-action', (responsesController, project) => {
				if (bookingCancellationModal.isEnabled()) {
					if (project.isMarketplaceBooking || project.isMarketplaceEnquiry) {
						bookingCancellationModal.renderCancelBooking(
							project.projectId,
							project.buyerId,
						);
					}
				}
			});

			//Refresh list to reflect the new response status
			responses.on('response-status-changed', () => {
				setTimeout(() => {
					responses.refresh();
				}, 1000);
			});
			responses.on('estimate-updated', () => {
				activityLog.redraw();
			});
			activityLog.on('show_project_details', (projectId) => {
				responses.showProjectDetails();
			});

			activityLog.on('fetch_complete', () => {
				let lastActivityDate = activityLog.items.length
					? activityLog.items[0].date
					: null;
				setLastActivityOnResponseBar(lastActivityDate);
			});

			DashboardEmailTemplates.init();
			responses.init();

			// Show a success message when the email is sent
			$(document)
				.off('email-template-sent')
				.on('email-template-sent', () => {
					tracking('seller-leads-dashboard-&-responses', 'Send email - success', {
						project_id: responses.project.projectId,
						project_response_id: responses.project.responseId,
						pagename: window.location.pathname,
						lead_type: 'project',
					});
					window.setTimeout(() => {
						modalManager.setBackdrop(true);
						modalManager.showSuccessModal(
							_t('seller_response_flow:send-email.email-sent-header'),
							'',
							2,
						);
					}, 500);
				});

			// Record when the buyer has been called
			Bark.callBuyer &&
				Bark.callBuyer.registerSuccessCallback(() => {
					responses.project.updateResponseContact('phone', true);
					setTimeout(() => {
						activityLog.redraw();
					}, 1000);
				});

			DashboardEmailTemplates.on('success', () => {
				setTimeout(() => {
					activityLog.redraw();
				}, 1000);
			});
			tracking('seller-leads-dashboard-&-responses', 'View my responses');
		});
	} catch (e) {
		console.log(e);
	}
}
